module.exports = { id: "chain-guard", url: "/build/app/img/symbols.svg#chain-guard", viewBox: "", toString: function() { return this.url; } };